<p>pre-complete-profile works!</p>
